import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Article } from '../../models/article.model';
import { ArticlesService } from '../../services/articles.service';
import { Category } from '../../models/category.model';
import { CategoriesService } from '../../services/categories.service';
import { AnnouncementsService } from '../../services/announcements.service';
import { Announcement } from '../../models/announcement.model';
import { DatePipe } from '@angular/common';
import { Album } from '../../models/album.model';
import { AlbumsService } from '../../services/albums.service';

@Component({
  selector: 'app-home',
  imports: [RouterLink, DatePipe],
  templateUrl: './home.component.html',
  styles: `
    .bg-image {
      background-image:
        linear-gradient(rgba(4, 59, 56, 0), #043b38),
        url('/assets/img/home_background.png');
      background-position: center;
      height: 500px;
      background-size: cover;

      @media screen and (max-width: 768px) {
        height: 800px;
      }
    }

    .bg-image-3 {
      background-image: linear-gradient(45deg, rgba(4, 59, 56, 0), #043b38);
      background-position: center;
      height: 500px;
      background-size: cover;
      position: absolute;
    }

    .square {
      width: 30px;
      height: 30px;
      background-color: #176460;
    }

    .title {
      font-size: 4.5rem;
    }

    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }

    .cursor-zoom {
      cursor: zoom-in;
    }

    .custom-img-wrapper {
      .bg-shape {
        background-color: #014437;
        top: 2rem;
        left: 2rem;
        z-index: 0;
      }

      img {
        z-index: 1;
      }
    }
  `
})
export class HomeComponent implements OnInit {
  articles: Article[] = [];
  categories: Category[] = [];
  announcements: Announcement[] = [];
  album?: Album;
  loadingArticles = true;
  loadingCategories = true;
  loadingAnnouncements = true;

  private articlesService = inject(ArticlesService);
  private categoriesService = inject(CategoriesService);
  private announcementsService = inject(AnnouncementsService);
  private albumsService = inject(AlbumsService);

  ngOnInit() {
    this.getArticles();
    this.getCategories();
    this.getAnnouncements();
    this.getAlbums();
  }

  getArticles() {
    this.articlesService.getAll().subscribe({
      next: (res) => {
        if (res.data.records) {
          this.articles = res.data.records.slice(0, 4);
        }
        this.loadingArticles = false;
      },
      error: () => {
        this.loadingArticles = false;
      }
    });
  }

  getCategories() {
    this.categoriesService.getAll().subscribe({
      next: (res) => {
        this.categories = res.data;
        this.loadingCategories = false;
        this.getQuantityItems(this.categories);
      },
      error: () => {
        this.loadingCategories = false;
      }
    });
  }

  getQuantityItems(categories: Category[]) {
    categories.forEach((category) => {
      this.articlesService.getAll({ category_id: category.id }).subscribe({
        next: (res) => {
          category.quantityItems = res.data.records.length;
        },
        error: () => {
          category.quantityItems = 0;
        }
      });
    });
  }

  getAnnouncements() {
    this.announcementsService.getAll().subscribe({
      next: (res) => {
        this.announcements = res.data.records;
        this.loadingAnnouncements = false;
      },
      error: () => {
        this.loadingAnnouncements = false;
      }
    });
  }

  getAlbums() {
    this.albumsService.getAll().subscribe({
      next: (res) => {
        for (const record of res.records) {
          if (record.id === 10) {
            continue;
          }
          this.album = record;
          break;
        }
      },
      error: (err) => {
        console.error('Error fetching albums:', err);
      }
    });
  }
}
